import { Component, OnInit } from '@angular/core';
import { ManagedContentService } from '../shared/service/managed-content.service';
import { CmSection, ContentType } from '../shared/model/cm/managed-content.model';
import { PagetitleService } from '../shared/service/pagetitle.service';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { GlobalConstants } from '../shared/global-constants';

@Component({
  selector: 'app-invalid-policy-number',
  standalone: true,
  imports: [ReactiveFormsModule],
  templateUrl: './invalid-policy-number.component.html',
  styleUrls: ['./invalid-policy-number.component.scss'],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InvalidPolicyNumberComponent implements OnInit {

  public readonly pageIllustrationUrl = 'assets/Illustration-Footer-Base-Mountains.svg';
public readonly alertLogoUrl = GlobalConstants.alertLogo;
  invalidCustomUrlContent: CmSection;
  ceoiPolicyFlagContent: CmSection;
   public ceoiPolicyFlag: boolean = false;
  constructor(private cmService: ManagedContentService, private pagetitleService: PagetitleService) { }

  ngOnInit() {
    this.invalidCustomUrlContent = this.cmService.getContentById(ContentType.SECTION, "custom-form-not-found");
    this.ceoiPolicyFlagContent = this.cmService.getContentById(ContentType.SECTION, "do-not-apply-here");
    
    this.pagetitleService.setPageTitle('Invalid Policy Number');
     this.ceoiPolicyFlag = sessionStorage.getItem(GlobalConstants.CEOI_POLICY_FLAG) === 'true';
     
          if(this.ceoiPolicyFlag){
                let endPart: string = this.ceoiPolicyFlagContent.body;
                  endPart = endPart.replace('<p>', "");
                  endPart = endPart.replace('</p>', "");
                  this.ceoiPolicyFlagContent.body = endPart;
                  sessionStorage.removeItem(GlobalConstants.CEOI_POLICY_FLAG);
              }
  }

}
